import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { env } from './lib/env';
import '@marcianus/design/tokens/tokens.css'; // paleta canónica do MDS — partilhada com a consola HQ
import '@marcianus/design/theme/theme.css';  // temas claro/escuro dinâmicos
import './app/global.css';
import '../../../packages/design/components/mds.css';  // MDS = classes + tokens não-cromáticos. Vive no shared: é o MESMO em www e HQ.

async function bootstrap() {
  // Mocks isolados: só carregam em dev quando explicitamente ligados.
  // Nunca são incluídos no bundle de produção.
  if (env.mocksEnabled) {
    const { worker } = await import('./mocks/browser');
    await worker.start({ onUnhandledRequest: 'bypass' });
  }
  const el = document.getElementById('root');
  if (!el) throw new Error('#root não encontrado');
  createRoot(el).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );

  // Fade-out suave do splash de arranque (index.html) assim que a app monta.
  // requestAnimationFrame duplo garante que a app já pintou o 1º frame antes de
  // revelarmos — sem flash entre o splash e a UI real.
  requestAnimationFrame(() => requestAnimationFrame(() => {
    const splash = document.getElementById('initial-splash');
    if (!splash) return;
    splash.classList.add('is-hiding');
    splash.addEventListener('transitionend', () => splash.remove(), { once: true });
    // Fallback: remove mesmo que transitionend não dispare (reduced-motion).
    setTimeout(() => splash.remove(), 700);
  }));
}

void bootstrap();
